import classNames from 'classnames/bind';
import { DateFormat, DurationMap } from 'common/types';
import { days, isStayDuration } from 'common/utils';
import {
  SearchType,
  getLinkPair,
  getPassengerDesc,
  getSeatDesc,
} from 'contexts/searchParams';
import { IFlightSearchHistory, ITripDesc } from 'hooks/useHistory';
import Link from 'next/link';
import styles from '../index.module.scss';
import Routes from './Routes';

const cx = classNames.bind(styles);

interface IProps {
  history: IFlightSearchHistory;
  deleteHistory: Function;
}

const getDuration = (tripList: ITripDesc[]) => {
  if (!(tripList && tripList.length > 0)) return '';
  const departureDates = [tripList[0].departureDate];
  if (tripList.length > 1) {
    departureDates.push(tripList[tripList.length - 1].departureDate);
  }
  return departureDates
    .map((date, index) =>
      index === 1 && isStayDuration(date)
        ? DurationMap.get(date)
        : days(date, DateFormat.YMD).format(DateFormat.DotYMD),
    )
    .join(' ~ ');
};

function Item({ history, deleteHistory }: IProps) {
  const {
    historyId,
    isDirect,
    tripList,
    trip,
    passenger,
    searchType,
    fareType,
  } = history;

  const { adult, child, infant } = passenger;

  const itinenary = tripList.map(_trip => ({
    departureCity: {
      code: _trip.departureCityCode,
      name: _trip.departureCityName,
      isDomestic: _trip.isDomesticDeparture,
    },
    arrivalCity: {
      code: _trip.destinationCityCode,
      name: _trip.destinationCityName,
      isDomestic: _trip.isDomesticDestination,
    },
    departureDate: _trip.departureDate,
  }));

  const [href, as] = getLinkPair(
    itinenary,
    { adult, child, infant: infant || 0 },
    fareType,
    isDirect,
    searchType,
  );

  return (
    <li className={cx('Item')}>
      <Link
        className={cx('anchor')}
        href={href}
        as={as}
        data-event-nlog="click"
        data-event-arae-code="mai.recent"
      >
        <Routes
          isDirect={isDirect}
          tripList={tripList}
          tripType={trip}
          searchType={searchType}
        />
        <b className={cx('duration')}>{getDuration(tripList)}</b>
        <i className={cx('info')}>
          {getPassengerDesc({ adult, child, infant })},{' '}
          {getSeatDesc(searchType === SearchType.DOMESTIC, fareType)}
        </i>
      </Link>
      <button
        type="button"
        className={cx('delete')}
        data-event-nlog="click"
        data-event-area-code="mai.del"
        onClick={() => deleteHistory(historyId)}
      />
    </li>
  );
}

export default Item;
